// HeaderNavigationContext.tsx
import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  FC,
} from "react";

interface HeaderNavigationContextType {
  isNavOpen: boolean;
  setIsNavOpen: (isOpen: boolean) => void;
  sectionId: string;
  setSectionId: (id: string) => void;
}

const HeaderNavigationContext = createContext<
  HeaderNavigationContextType | undefined
>(undefined);

interface HeaderNavigationProviderProps {
  children: ReactNode;
}

export const HeaderNavigationProvider: FC<HeaderNavigationProviderProps> = ({
  children,
}) => {
  const [isNavOpen, setIsNavOpen] = useState<boolean>(false);
  const [sectionId, setSectionId] = useState<string>("");

  return (
    <HeaderNavigationContext.Provider
      value={{ isNavOpen, setIsNavOpen, sectionId, setSectionId }}
    >
      {children}
    </HeaderNavigationContext.Provider>
  );
};

export const useHeaderNavigationContext = (): HeaderNavigationContextType => {
  const context = useContext(HeaderNavigationContext);
  if (!context) {
    throw new Error(
      "useHeaderNavigationContext must be used within a HeaderNavigationProvider"
    );
  }
  return context;
};
